module.exports = __webpack_public_path__ + "static/media/ApprovalVibes.a5ab0f8d.mp3";